var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"human-index"},[_c('headerw',{ref:"headerw"}),_c('div',{staticClass:"human-content"},[_c('leftnav',{on:{"navchange":_vm.navchange,"temload":_vm.temload}}),_c(_vm.getComp(_vm.tempactive),{tag:"component",on:{"updatainfo":_vm.updatainfo}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }